import { Arg, Args, Ctx, Directive, FieldResolver, Query, Resolver, Root } from 'type-graphql'

import { User } from '@things-factory/auth-base'
import { Domain, getRepository, ListParam, getQueryBuilderFromListParams } from '@things-factory/shell'

import { PartnerSetting } from '../partner-setting/partner-setting'
import { Setting } from './setting'
import { SettingList } from './setting-type'

@Resolver(Setting)
export class SettingQuery {
  @Directive('@privilege(category: "setting", privilege: "query", domainOwnerGranted: true)')
  @Query(returns => Setting, { description: 'To fetch a Setting' })
  async setting(
    @Arg('name') name: string,
    @Arg('partnerDomainId', { nullable: true }) partnerDomainId: string,
    @Ctx() context: ResolverContext
  ): Promise<Setting> {
    const { domain } = context.state

    let setting: Setting = await getRepository(Setting).findOne({ where: { domain: { id: domain.id }, name } })
    if (!setting) throw new Error(`${name} setting not found`)

    if (partnerDomainId) {
      const partnerDomain: Domain = await getRepository(Domain).findOneBy({ id: partnerDomainId })
      const partnerSetting: PartnerSetting = await getRepository(PartnerSetting).findOneBy({
        setting: { id: setting.id },
        domain: { id: domain.id },
        partnerDomain: { id: partnerDomain.id }
      })
      if (partnerSetting) setting.value = partnerSetting.value
    }

    return setting
  }

  @Directive('@privilege(category: "setting", privilege: "query", domainOwnerGranted: true)')
  @Query(returns => SettingList, { description: 'To fetch multiple Settings' })
  async settings(@Args(type => ListParam) params: ListParam, @Ctx() context: ResolverContext): Promise<SettingList> {
    const { domain } = context.state
    const queryBuilder = getQueryBuilderFromListParams({
      repository: getRepository(Setting),
      params,
      domain,
      searchables: ['name', 'description', 'category']
    })

    const [items, total] = await queryBuilder.getManyAndCount()
    return { items, total }
  }

  // @FieldResolver(type => Domain)
  // async value(@Root() setting: Setting, @Ctx() context: ResolverContext) {
  //   const { user, domain } = context.state
  //   const userDomains: Domain[] = user.domains
  //   let value: string = setting.value

  //   const partner: Partner = await getRepository(Partner).findOne({
  //     where: { domain: { id: domain.id }, partnerDomain: { id: In(userDomains.map((userDomain: Domain) => userDomain.id)) } },
  //     relations: ['partnerDomain']
  //   })
  //   if (partner?.partnerDomain) {
  //     const partnerSetting: PartnerSetting = await getRepository(PartnerSetting).findOne({
  //       setting,
  //       domain,
  //       partnerDomain: partner.partnerDomain
  //     })
  //     if (partnerSetting) value = partnerSetting.value
  //   }

  //   return value
  // }

  @FieldResolver(type => Domain)
  async domain(@Root() setting: Setting) {
    return await getRepository(Domain).findOneBy({ id: setting.domainId })
  }

  @FieldResolver(type => User)
  async updater(@Root() setting: Setting): Promise<User> {
    return await getRepository(User).findOneBy({ id: setting.updaterId })
  }

  @FieldResolver(type => User)
  async creator(@Root() setting: Setting): Promise<User> {
    return await getRepository(User).findOneBy({ id: setting.creatorId })
  }
}
